import React, {FC} from "react"

import {H5, H6, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import mainTheme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import FormattedMessage from "@irati/utils/lang"
import {Team, CelebrationsReportTeam, CelebrationsReportUser} from "@irati/types"

import PictureGroup from "../PictureGroup"
import {StyledCard, FlexStartH6} from "./styled"

interface Props {
  isReceived: boolean,
  index: number,
  topCelebratedUser?: CelebrationsReportUser,
  topCelebratedTeam?: CelebrationsReportTeam
}

const RecognitionCard: FC<Props> = ({isReceived, topCelebratedUser, topCelebratedTeam, index}) => {
  const {recognitionIds, companyValues} = topCelebratedUser || topCelebratedTeam
  const celebrationsText = isReceived
    ? "admin.reporting.celebrations.recognitionCard.celebrations.received"
    : "admin.reporting.celebrations.recognitionCard.celebrations.given"
  const firstTeam = topCelebratedUser?.user.teams.results.find((team: Team) =>
    team.public_name !== "$$TEAM_ROOT$$" && !team.public_name.includes("platform.billingUnit"))?.public_name

  return (
    <StyledCard marginBottom={2} bgColor={mainTheme.colors.greys.lightest} padding={2}>
      <Flex marginBottom={1} alignItems="flex-start">
        <FlexStartH6 color={mainTheme.colors.primary1} marginRight={1}>{index + 1}</FlexStartH6>
        {topCelebratedUser && <ProfilePicture small user={topCelebratedUser.user} />}
        <Flex marginLeft={1} direction="column">
          {topCelebratedUser && <>
            <H6>{topCelebratedUser.user.firstName} {topCelebratedUser.user.lastName}</H6>
            {firstTeam && <Label small>{firstTeam}</Label>}
            {topCelebratedUser?.regionName && <Label small>{topCelebratedUser?.regionName}</Label>}
          </>}
          {topCelebratedTeam && <H6>{topCelebratedTeam.team.teamName}</H6>}
        </Flex>
      </Flex>
      {topCelebratedTeam && <PictureGroup users={topCelebratedTeam.team.users.results} size={24} />}
      <Card padding={mainTheme.spacing.oneAndHalf}>
        <Label small marginBottom>
          <FormattedMessage id={celebrationsText} />
        </Label>
        <H5>{recognitionIds.length}</H5>
        <Label small marginBottom>
          <FormattedMessage id="admin.reporting.celebrations.recognitionCard.values.tagged" />
        </Label>
        <PictureGroup values={companyValues} />
      </Card>
    </StyledCard>

  )
}

export default RecognitionCard
